<template>
  <div class="md-card">
    <div class="md-card-content">
      <div class="md-layout">
        <div class="md-layout-item md-size-100 flex justify-around py-4">
          <SummaryBox :content="data.status" title="common.status"></SummaryBox>
          <SummaryBox
            :content="data.count_respondent"
            title="survey_report.responded"
          ></SummaryBox>
          <SummaryBox
            :content="data.count_not_respondent"
            title="survey_report.not_responded"
          ></SummaryBox>
          <SummaryBox
            :content="data.responded_rate + ' %'"
            title="survey_report.responded_rate"
          ></SummaryBox>
        </div>
        <div class="md-layout-item md-size-100 pt-4 font-medium text-[#1B1F22]">
          Campaign detail
        </div>
        <div class="md-layout md-size-100 md-layout flex justify-between">
          <div class="md-layout-item md-size-25">
            <md-field>
              <md-select v-model="selectedStatus">
                <md-option
                  v-for="(item, index) in sendingList"
                  :key="index + 'status'"
                  :value="item.id"
                >
                  {{ $t(item.name) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-75 text-right">
            <md-button class="md-warning" @click="exportFile">Export</md-button>
          </div>
        </div>
        <div class="md-layout-item md-size-100" v-if="tableData.length">
          <YvTable
            :tableData="tableData"
            :pagination="pagination"
            :columns="tableHeader"
            :hideBulkAction="true"
            :sort-data="sortData"
            :hideNoNumber="true"
            :tableActionsComponent="TableActions"
          >
          </YvTable>
          <YvPagination
            :pagination="pagination"
            @changePage="changePage"
            class="my-4"
          />
        </div>
        <div class="md-layout-item md-size-100 flex text-center" v-else>
          <NoDataFound></NoDataFound>
        </div>
      </div>
    </div>
    <common-modal
      width="60%"
      height="auto"
      name="SurveyReportDetail"
      :hideFooter="true"
      :title="$t('survey_report.responded_detail') + ' : ' + reportDetail.name"
    >
      <template #modal-body>
        <SurveyDetailModal
          :reportDetail="reportDetail"
          :surveyQuestions="surveyQuestions"
          modalName="SurveyReportDetail"
        ></SurveyDetailModal>
      </template>
    </common-modal>
  </div>
</template>
<script>
import SummaryBox from "./SummaryBox";
import YvTable from "@/components/Base/YvTable";
import YvPagination from "@/components/Base/YvPagination";
import TableActions from "./TableActions";
import SurveyDetailModal from "./SurveyDetailModal";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { formatDateClient } from "../../../helpers/datetime-helper";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    SummaryBox,
    YvTable,
    YvPagination,
    SurveyDetailModal
  },
  data() {
    return {
      TableActions,
      data: "",
      sendingList: [
        { id: "", name: "common.all" },
        { id: "Responded", name: "survey_report.responded" },
        { id: "Not responded", name: "survey_report.not_responded" }
      ],
      selectedStatus: "",
      tableHeader: {
        respondent_info: "survey_report.respondent_info",
        role: "staff.roles",
        sent_email: "survey_report.sent_email",
        sent_datetime: "survey_report.sent_datetime",
        submission_datetime: "survey_report.submission_datetime",
        status: "common.status"
      },
      tableData: [],
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 1,
        hidePaging: false,
        hidePerPageOptions: true
      },
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      reportDetail: {},
      surveyQuestions: []
    };
  },
  created() {
    this.fetchSurvey();
    this.fetchSurveyReport();
  },
  watch: {
    selectedStatus(value) {
      this.fetchSurveyReport();
    }
  },
  computed: {
    surveyId() {
      return this.$route.params.id;
    },
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    convertTimezone(time, zone) {
      const moment = require("moment-timezone");
      if (!time) return "";
      return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
        .tz(zone)
        .format(`${formatDateClient} HH:mm:ss`);
    },
    fetchSurvey() {
      this.$axios.get(`${service_paths.survey}/${this.surveyId}`).then(res => {
        this.surveyQuestions = res.data.survey_structure.questions;
      });
    },
    fetchSurveyReport() {
      let params = {
        page: this.pagination.currentPage
      };
      if (this.selectedStatus) {
        params.sending_status = this.selectedStatus;
      }
      this.$axios
        .get(
          `${service_paths.report_surveys}/${this.surveyId}/individual`,
          params
        )
        .then(res => {
          if (res.data.appearance_report_setting) {
            delete this.tableHeader.role;
            delete this.tableHeader.sent_email;
          }
          this.data = res.data;
          this.tableData = this.formatTableData(res.data.users.data);
          this.pagination.from = res.data.users.from;
          this.pagination.to = res.data.users.to;
          this.pagination.total = res.data.users.total;
          this.$emit("updateTitle", res.data.title_survey);
        });
    },
    formatTableData(data) {
      let isAnonymous = this.data.appearance_report_setting;
      return data.map(item => ({
        name: item.name,
        respondent_info: isAnonymous
          ? item.name
          : this.renderStudent(item.avatar_url, item.name, item.student_code),
        role: isAnonymous ? "" : item.role_name.join(","),
        sent_email: isAnonymous ? "" : item.email,
        sent_datetime: this.convertTimezone(
          item.sent_datetime,
          this.userTz || moment.tz.guess()
        ),
        submission_datetime: this.convertTimezone(
          item.submission_datetime,
          this.userTz || moment.tz.guess()
        ),
        status: `<span class="${
          item.status === "Responded" ? "text-[#4CAF50]" : "text-[#F44336]"
        }">${item.status}</span>`,
        answers: item.data_answers,
        hasDetail: item.status === "Responded"
      }));
    },
    renderStudent(avatarUrl, name, code) {
      return `<div class="flex items-center">
     <img
       src="${avatarUrl || "/img/avt_placeholder.jpg"}"
       class="object-cover rounded-full w-[42px] h-[42px]"/>
     <div class="text-left pl-4 flex flex-col ">
       <p class="font-medium break-all" >${name}</p>
       <p class="break-all">${code || ""}</p>
     </div>
   </div>`;
    },

    viewReportDetail(report) {
      this.reportDetail = report;
      this.$modal.show("SurveyReportDetail");
    },

    changePage(value) {
      this.pagination.currentPage = value;
      this.fetchSurveyReport();
    },
    exportFile() {
      this.$axios
        .get(
          `${service_paths.report_surveys}/${this.surveyId}/export`,
          { is_export: true },
          undefined,
          undefined,
          "blob"
        )
        .then(res => {
          if (res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "survey_report.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            Message.success(this.$t("survey_report.export_successfully"));
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    }
  },
  provide() {
    return {
      viewReportDetail: this.viewReportDetail
    };
  }
};
</script>
<style lang="scss" scoped></style>
